const map = {
	"./admin.json": 6467,
	"./auth.json": 8094,
	"./automations.json": 8208,
	"./canned.json": 9397,
	"./claude.json": 7330,
	"./common.json": 4529,
	"./customers.json": 9977,
	"./dashboard.json": 7248,
	"./errors.json": 1323,
	"./globalSearch.json": 5699,
	"./kb.json": 5633,
	"./layout.json": 8934,
	"./mailbox.json": 5804,
	"./meetings.json": 5670,
	"./notifications.json": 2912,
	"./portal.json": 3318,
	"./privacy.json": 2100,
	"./profile.json": 4405,
	"./projectCsv.json": 1035,
	"./projectDetail.json": 4176,
	"./projectTemplates.json": 8156,
	"./projectView.json": 7868,
	"./projects.json": 4986,
	"./reports.json": 7039,
	"./rules.json": 6403,
	"./slaSettings.json": 475,
	"./tags.json": 8014,
	"./tickets.json": 7589
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9605;